import { AdminService } from '../services/admin.service'
import { adminConstants } from '../constants/admin.constants'

const getBalancePoints = () => async dispatch => {
	dispatch({
		type: adminConstants.LOADING_POINTS
	})

	return AdminService.getBalancePoints()
		.then(points => {
			dispatch(updateBalancePoints(points))
			dispatch({
				type: adminConstants.POINTS_WAS_LOADED
			})
		})
		.catch(error => {
			dispatch(updateBalancePoints(null))
			dispatch({
				type: adminConstants.POINTS_WAS_LOADED
			})
		})
}

const updateBalancePoints = points => dispatch => {
	dispatch({
		type: adminConstants.GET_BALANCE_POINTS,
		payload: points
	})
}

const addViewBalancePoints = points => dispatch => {
	dispatch({
		type: adminConstants.ADD_VIEW_BALANCE_POINTS,
		payload: points
	})
}

export const adminActions = {
	getBalancePoints,
	updateBalancePoints,
	addViewBalancePoints
}
